import InfiniteScroll from 'react-infinite-scroller';
import { AbconetApi } from './AbconetApi';
import ItemListing from '../Product/ProductListing';
var getQueryParams = require('./Helper.jsx').getQueryParams;

export class SearchResults extends React.Component {
    constructor(props) {
        super();
        this.state = {
            itemCollection: [],
            hasMoreItems: true,
            hasSearched: false
        };
    }

    loadItems(page) {
        AbconetApi.get(`/api/product/?term=${encodeURIComponent(this.props.searchTerm)}&page=${page}&itemsPerPage=10`).then((data) => {
            if (data.length == 0) {
                this.setState({ hasMoreItems: false });
            }
            else {
                var existingData = this.state.itemCollection;
                for (var i = 0; i < data.length; i++) {
                    existingData.push(data[i]);
                }

                this.setState({ itemCollection: existingData, hasSearched:true });
            }
        });
    }

    render() {
        const loader = <div className="loader">Loading ...</div>;

        var message = <h2>Search result containing: {this.props.searchTerm}</h2>;
        if (this.state.itemCollection.length === 0 && this.state.hasSearched) {
            message = <h2>No result found for: {this.props.searchTerm}</h2>;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        {message}
                    </div>
                </div>
                <InfiniteScroll
                    key="infinite-scroll"
                    pageStart={0}
                    loadMore={this.loadItems.bind(this)}
                    hasMore={this.state.hasMoreItems}
                    loader={loader}
                >
                    <ItemListing key="item-listing"
                        productCollection={this.state.itemCollection}
                        canAddToCart={this.props.canAddToCart}
                        limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                        limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}
                        disableItemReplacement={this.props.disableItemReplacement}
                    />
                </InfiniteScroll>
            </div>
        );

    }
}